// @flow

import * as React from 'react';
import classNames from 'classnames';
import useSheet from '../../jss';

type Props = {
  className?: string,
  children?: any,
  component?: React.ReactNode,
  gutter?: boolean,
  gutterLargeDevices?: boolean,
  fullWidth?: boolean,
  sheet: Object,
  size?: 'small' | 'medium' | 'large'
};

const defaultProps = {
  className: undefined,
  children: undefined,
  component: 'div',
  gutter: false,
  fullWidth: false,
  gutterLargeDevices: false,
  size: 'medium'
};

function Container({
  className,
  children,
  component,
  gutter,
  gutterLargeDevices,
  fullWidth,
  sheet: { classes },
  size
}: Props) {
  return React.createElement(
    component,
    {
      className: classNames(
        classes.default,
        classes[size],
        {
          [classes.gutter]: gutter,
          [classes.gutterLargeDevices]: gutterLargeDevices,
          [classes.fullWidth]: fullWidth
        },
        className
      ),
      size
    },
    children
  );
}

Container.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    default: {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '100%'
    },
    gutter: {
      paddingLeft: theme.spacing.small,
      paddingRight: theme.spacing.small
    },
    gutterLargeDevices: {
      paddingLeft: 0,
      paddingRight: 0
    },
    [theme.mediaQuery.desktopAndUp]: {
      small: { maxWidth: 480 },
      medium: { maxWidth: 760 },

      gutterLargeDevices: {
        paddingLeft: theme.spacing.default,
        paddingRight: theme.spacing.default
      },
      large: {
        marginLeft: '12vw',
        maxWidth: 1140,
        width: '88vw'
      },
      fullWidth: {
        width: '100%',
        maxWidth: 1920,
        marginLeft: 'auto'
      }
    },
    [theme.mediaQuery.desktopLargeOnly]: {
      large: {
        marginLeft: 'auto',
        width: '76vw'
      },
      fullWidth: {
        width: '100%'
      }
    }
  };
}

export default useSheet(applyStyles)(Container);
